import { useQuery } from '@tanstack/react-query';

import { getTours } from '../api/take-a-tour.api';

export const useTakeATourInit = () => {
	const {
		data: tourSteps,
		error,
		isPending,
	} = useQuery({
		queryKey: ['GET_TOUR_STEPS'],
		queryFn: getTours,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
		enabled: true,
	});

	return {
		tourSteps,
		error,
		isPending,
	};
};
